import { colors } from '@btime/constants'
import { propOr } from 'ramda'

const STATUS_COLORS = {
  open: colors.red,
  inProgress: colors.orange,
  done: colors.green
}

export const getNonComplianceStatusColor = status => propOr(colors.dark5, status, STATUS_COLORS)
